import type { IChartDataResult, MetricTab } from "@/pages/CreatorAnalytics/types";

export const buildChartOptions = (chartDataResult: IChartDataResult, activeTab: MetricTab, textColor: string, gridlineColor: string) => ({
  curveType: "function" as const,
  legend: { position: "top" as const, textStyle: { fontSize: 12, color: textColor } },
  hAxis: {
    textStyle: { fontSize: 10, color: textColor },
    titleTextStyle: { color: textColor },
    gridlines: { color: "transparent" },
    format: "MMM d",
    slantedText: true,
    slantedTextAngle: 45,
  },
  vAxis: {
    title: chartDataResult.vAxisTitle,
    textStyle: { fontSize: 10, color: textColor },
    titleTextStyle: { color: textColor },
    gridlines: { color: gridlineColor },
    minValue: 0,
  },
  colors: chartDataResult.colors,
  chartArea: { width: "85%", height: "70%" },
  backgroundColor: "transparent",
  series: activeTab === "rating" ? { 0: { targetAxisIndex: 0 }, 1: { targetAxisIndex: 1 } } : undefined,
  vAxes:
    activeTab === "rating"
      ? {
          0: {
            title: "Rating (0\u20131)",
            minValue: 0,
            maxValue: 1,
            textStyle: { color: textColor },
            titleTextStyle: { color: textColor },
          },
          1: {
            title: "Count",
            minValue: 0,
            textStyle: { color: textColor },
            titleTextStyle: { color: textColor },
          },
        }
      : undefined,
});
